import React, { useState } from 'react'
import { t } from '../../../i18n/i18n'
import { ConsequenceAndProbabilityRisk } from '../../../api/schemas/schema'
import { Button, makeStyles, Popover, PopoverSurface, PopoverTrigger, Text, tokens } from '@fluentui/react-components'
import { Dismiss20Regular } from '@fluentui/react-icons'
import TextOutput from '../../common/inputs/TextOutput'
const useStyles = makeStyles({
   brand: {
      color: tokens.colorNeutralForeground2BrandSelected,
   },
   surface: {
      backgroundColor: tokens.colorBrandBackground2,
      width: '800px',
      maxWidth: '100%',
      boxSizing: 'border-box',
   },
   spaceBtw: {
      display: 'flex',
      justifyContent: 'space-between',
      '> *': {
         marginBottom: 0,
      },
   },
   bodyWrapper: {
    marginTop: tokens.spacingVerticalXL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXL,
 },
})

type BiggestRiskProps = {
   risk: ConsequenceAndProbabilityRisk
}
export const BiggestRisk = ({ risk }: BiggestRiskProps) => {
   const [open, setOpen] = useState<boolean>(false)
   const classes = useStyles()

   return (
      <>
         <Popover open={open} onOpenChange={(e, data) => setOpen(data.open ?? false)} size="large">
            <PopoverTrigger>
               <Button className={open ? classes.brand : ''} appearance="transparent">
                  <Text size={400}>{risk.scenario}</Text>
               </Button>
            </PopoverTrigger>
            <PopoverSurface className={classes.surface}>
               <header className={classes.spaceBtw}>
                  <Text as="h4" size={500} weight={'semibold'}>
                     {risk.scenario}
                  </Text>
                  <Button className={open ? classes.brand : ''} onClick={() => setOpen(false)} appearance="transparent" icon={<Dismiss20Regular />} />
               </header>
               <div className={classes.bodyWrapper}>
                  <TextOutput label={t('ConsequenceDescription')} text={risk.consequence} />
                  <TextOutput label={t('RiskSource')} text={risk.source} />
                  <TextOutput label={t('WeaknessesOrCurrentProtection')} text={risk.currentState} />
                  <TextOutput label={t('UnderlyingMotivationAndStand')} text={risk.underlyingMotivation} />
               </div>
            </PopoverSurface>
         </Popover>
      </>
   )
}
